<template>
  <div class="container">
    <section class="content-header">
      <h1>{{$t('メールアドレスの変更')}}</h1>
    </section>
    <section class="content-wrap">
      <div class="col-signup col-center">

        <div class="warning" id="warning" v-if="errors.length">
          <ul>
            <li v-for="(error, index) in errors" :key="index"> {{ error }}</li>
          </ul>
        </div>

        <form id="signup" class="mail-confing"  @submit.prevent="modifyEmail">
          <dl class="mail-current">
            <dt>{{$t('現在のメールアドレス')}}</dt>
            <dd>{{this.$store.getters.email}}</dd>
          </dl>
          <input v-model="newEmail" v-on:blur="instantValidator($event, 'email')" name="email" :placeholder="this.$t('新しいメールアドレス')" id="email" autocomplete="email" value="" type="text" spellcheck="false" />
          <p class="caution" id="email-c">{{emailError}}</p>

          <button v-bind:style="[emailError ? {'pointer-events':'none', 'background-color':'#c9cbcc'} : {}]" type="submit">{{$t('変更する')}}</button>
        </form>
      </div>
    </section>
  </div>  
</template>




<script>
import { mapState, mapGetters } from 'vuex'
import User from '@/api/user'
import UserUtils from '@/utils/UserUtils'
import cognitoUser from '@/api/cognito-user'

export default {
  mounted () {
    // console.log(cognitoUser.getUserData)
  },
  computed:{
    ...mapState(['user']),
    ...mapGetters({
      email: 'email',
      accessToken: 'accessToken',
      userId: 'userId'
    }),
  },
  data : () => ({
    newEmail: null,
    emailError: '',
    errors:[],
  }),
  methods:{
    instantValidator(el, type){
      if(type === undefined) return; 
      if(type === 'email'){
        if(!this.newEmail){
          this.emailError = this.$t("Email field is empty.")
        }else if(!this.emailValidator(this.newEmail)){
          this.emailError = this.$t("Invalid email adrress.")
        }else{
          this.emailError = ""
        }
      }
    },

    modifyEmail(){
      if (!this.checkForm()) return

      let bodyParams = {
        userId: this.userId,
        newEmail: this.newEmail,
        accessToken: this.accessToken
      }

      User.modifyEmailAttributes(bodyParams)
      .then((response) => {
        // console.log(response)
        let self = this
        if(response.status === 200){
          window.localStorage.setItem('newEmailForVerification', btoa(JSON.stringify(this.newEmail)))
          window.location.href = '/confirm'
        }else{
          var unVerified_code = this.getNestedObject(response.data, ['errors', 'message', 0, 'accessToken', 0])
          var unVerified_email = this.getNestedObject(response.data, ['errors', 'message', 0, 'email', 0])
          var unVerified_user_id = this.getNestedObject(response.data, ['errors', 'message', 0, 'user_id', 0])
          if(unVerified_code !== undefined){
            self.errors.push(this.$t(unVerified_code) || unVerified_code)
          }
          if(unVerified_email !== undefined){
            self.errors.push(this.$t(unVerified_email) || unVerified_email)
          }
          if(unVerified_user_id !== undefined){
            self.errors.push(this.$t(unVerified_user_id) || unVerified_user_id)
          }  
        }
      })
      .catch((error) => {
        let errorMsg = this.getNestedObject(error.errors, [ 'message', 0])
        if(errorMsg !== undefined){
          self.errors.push(this.$t(errorMsg) || errorMsg ) 
        }
      })
    },
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    emailValidator:function(email) {
      if (!email) return false;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email);
    },

    checkForm:function(e) {
      this.errors = [];
      if(!this.newEmail) {
        this.errors.push(this.$t("Please input a valid email address."));
      } else if(!this.validEmail(this.newEmail)) {
        this.errors.push(this.$t("Invalid email adrress."));        
      }
      if(!this.errors.length) return true;
    },

    getNestedObject: function(nestedObj, pathArr){
      return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    }
  },


  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('メールアドレスの変更') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.$store.state.languageName
      },
    }
  },  


}

</script>



// WEBPACK FOOTER //
// src/pages/settings/mail.vue